import {
  ApplicationConfig,
  ErrorHandler, inject, provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { initAuthentication } from '../api/auth';
import { AppErrorHandler } from '../errors';
import { ServicePortalApi } from '../api/api';
import { I18n, setLocaleId } from '../i18n';
import { StateService } from '../api/state';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(async () => {
      const i18n = inject(I18n);
      await initAuthentication();
      await i18n.setLocale();
    }),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    ServicePortalApi,
    StateService,
    provideZonelessChangeDetection(),
    provideRouter(routes),
    setLocaleId(),
  ],
};
